/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIncidentsList} from '../api'

 export const useQueryGetIncidentsList = createReactQueryHook('getIncidentsList', getIncidentsList)
